import script from "./ConnectedSocialPages.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConnectedSocialPages.vue?vue&type=script&lang=ts&setup=true"

import "./ConnectedSocialPages.vue?vue&type=style&index=0&id=d324a99c&lang=sass"

const __exports__ = script;

export default __exports__